import { SOURCE_TYPE } from '@trustero/trustero-api-web/lib/source/source_pb'

export const getIsDocumentSource = (sourceType: SOURCE_TYPE): boolean => {
  return (
    sourceType === SOURCE_TYPE.POLICY_DOC_SOURCE ||
    sourceType === SOURCE_TYPE.EVIDENCE_SOURCE ||
    sourceType === SOURCE_TYPE.KNOWLEDGE_BASE_SOURCE
  )
}
